import { RouteConfig } from "QuorumGrassroots/framework/helpers/RouteRegistry"
import { keyDatesRoutes } from "QuorumGrassroots/pages/campaign/key-dates/routes"

export const campaignRoutes: RouteConfig[] = [...keyDatesRoutes]
